module.exports = __webpack_public_path__ + "static/media/28DGC10.635a8fdf.jpg";